import { db } from "../firebase_setup/firebase";
import {
  collection,
  orderBy,
  limit,
  getDocs,
  query,
  where,
} from "firebase/firestore";

export const useFirestoreSuggestions = (props) => {

    const fetchSuggestionFallback = async (term) => {
        const formatted = term.trim().toUpperCase();
        if (formatted.length < 2) return;

        const isLinea = formatted === "CABALLERO" || formatted === "DAMA" || formatted === "UNISEX";

        let baseQuery;
        let snap;

        if (isLinea) {
            baseQuery = query(
                collection(db, "fragances"),
                orderBy("linea"),
                where("linea", ">=", formatted),
                where("linea", "<=", formatted + "\uf8ff"),
                limit(5)
            );
        } else {

            baseQuery = query(
                collection(db, "fragances"),
                orderBy("marca"),
                where("marca", ">=", formatted),
                where("marca", "<=", formatted + "\uf8ff"),
                limit(5)
            );

            snap = await getDocs(baseQuery);

            // 🔥 2. fallback a descripción SOLO si no hay resultados
            if (snap.empty) {
                baseQuery = query(
                    collection(db, "fragances"),
                    orderBy("descripcion_corta"),
                    where("descripcion_corta", ">=", formatted),
                    where("descripcion_corta", "<=", formatted + "\uf8ff"),
                    limit(5)
                );

                snap = await getDocs(baseQuery);
            }
        }

        const results = snap.docs.flatMap(d => {
            const { descripcion_corta, marca, linea } = d.data();

            return [descripcion_corta, marca, linea]
                .filter(Boolean)
                .map(v => v.trim().toUpperCase());
        })

        const unique = [...new Set(results)].slice(0, 6);

        if (unique.length === 0) {
            if (formatted.length <= 3) {
                props.setSuggestions(props.suggestionCache.slice(0, 6));
            } else {
                props.setSuggestions([]);
            }
            return;
        }

        props.setSuggestions(unique);

        const merged = [...new Set([...props.suggestionCache, ...unique])];

        props.setSuggestionCache(merged);

        localStorage.setItem(
            "fraganceSuggestions",
            JSON.stringify(merged)
        );
    };

    return{
        fetchSuggestionFallback
    }
}